import { productListFilterAccordionSectionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import AccordionSectionPanel from "@insite/mobius/AccordionSection/AccordionSectionPanel";
import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import { COLORS, SPACING, TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

Object.assign(productListFilterAccordionSectionStyles, {
    accordionSection: {
        titleTypographyProps: {
            css: css`
                text-transform: none;
            `,
        },
        panelProps: {
            css: css`
                overflow-y: auto;
                overflow: initial;
                border: none;
                margin-bottom: ${SPACING.xsmall};
                border-bottom: 1px solid ${getColor("common.border")};
                padding: 0 0 ${SPACING.standard} 0;
            `,
        },
        headerProps: {
            css: css`
                button {
                    padding: 1em 0;
                    border: none;
                    background-color: transparent;
                    border-top: 1px solid ${getColor("common.border")};

                    &[aria-expanded="false"] {
                        border-bottom: 1px solid ${getColor("common.border")};
                    }

                    &:focus {
                        padding: 1em 0;
                        padding-top: 1em !important;
                    }
                }
            `,
        },
    },
    checkBox: {
        css: css`
            span[role="checkbox"] {
                border-width: 1px;
                cursor: pointer;
                margin-top: 0.1em;
                border: 2px solid ${getColor("common.borderDark")};
                color: ${getContrastColor("common.borderDark")};
                background: transparent;
            }
        `,
    },
    checkBoxGroup: {
        css: css`
            span[role="checkbox"] {
                &[aria-checked="true"]:not([aria-disabled="true"]),
                &[aria-checked="mixed"]:not([aria-disabled="true"]) {
                    border: 2px solid ${getColor("common.borderDark")};
                    background: transparent !important;
                }
            }
        `,
    },
});
